import React, { FC } from "react"
import { Button, Title } from "dash-styled"

interface UserPlanExpiryBannerProps {
    expiryDays: number
    onContact: () => void
}

export const UserPlanExpiryBanner: FC<UserPlanExpiryBannerProps> = ({
    expiryDays,
    onContact
}) => {
    return (
        <div className="flex flex-col lg:flex-row p-4 mb-4 bg-rhino-250 rounded items-start lg:items-center">
            <div className="flex-grow">
                <Title
                    component="h3"
                    variant="heading4"
                    className="text-rhino-750"
                    noMargin={true}
                >
                    {expiryDays === 0
                        ? "Your trial has expired"
                        : `Your trial expires in ${expiryDays} day${
                              expiryDays === 1 ? "" : "s"
                          }`}
                </Title>
                <p className="text-rhino-600 my-1 text-sm">
                    {expiryDays === 0
                        ? "To continue using this service, please get in touch"
                        : "Get in touch to keep full access"}
                </p>
            </div>

            <Button
                onClick={onContact}
                variant="contained"
                color="darkviolet"
                className="flex-grow-0 flex-shrink-0 w-auto mt-2 ml-0 lg:mt-0 lg:ml-5 px-8"
                testId="trial-expiry-contact"
            >
                Contact us
            </Button>
        </div>
    )
}
